<div class="container">
  <mat-card>
    <form [formGroup]="workingDaysForm" (ngSubmit)="submit()">
      <mat-card-content>
        <div #workingDaysFormRef class="layout-column">
          <div class="layout-row responsive-column">
            <mat-label class="mat-h4 flex-50">{{ 'labels.inputs.Working Days' | translate }}</mat-label>
            <div class="flex-50 layout-column" formArrayName="recurrence">
              @for (day of recurrence.controls; track day; let i = $index) {
                <div>
                  <mat-checkbox labelPosition="after" [formControlName]="i">
                    {{ weekDays[i].name }}
                  </mat-checkbox>
                </div>
              }
            </div>
          </div>

          <mat-form-field>
            <mat-label>{{ 'labels.inputs.Payments due on non working days' | translate }}</mat-label>
            <mat-select formControlName="repaymentRescheduleType">
              @for (repaymentRescheduleType of repaymentRescheduleTypeData; track repaymentRescheduleType) {
                <mat-option [value]="repaymentRescheduleType.id">
                  {{ repaymentRescheduleType.value }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-checkbox labelPosition="before" formControlName="extendTermForDailyRepayments">
            {{ 'labels.inputs.Loans daily repayment schedule' | translate }}
          </mat-checkbox>
        </div>
      </mat-card-content>

      <mat-card-actions class="layout-row align-center gap-5px responsive-column">
        <button mat-raised-button [routerLink]="['../']">{{ 'labels.buttons.Cancel' | translate }}</button>
        <button
          mat-raised-button
          color="primary"
          [disabled]="workingDaysForm.pristine"
          *LOSxHasPermission="'UPDATE_WORKINGDAYS'"
        >
          {{ 'labels.buttons.Submit' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>

<ng-template #templateWorkingDaysFormRef let-data let-popover="popover">
  <h2>{{ 'labels.heading.Working Days' | translate }}</h2>
  <p class="mw400">
    {{ 'labels.text.Click (Define Working Days)' | translate }}:
    <a href="https://LOSforge.jira.com/wiki/spaces/docs/pages/90243212/Working+Days" target="_blank">{{
      'labels.inputs.Working Days' | translate
    }}</a>
  </p>
  <div class="layout-row align-end gap-2px responsive-column">
    <button mat-raised-button color="warn" (click)="popover.close(); configurationWizardService.closeConfigWizard()">
      {{ 'labels.buttons.Close' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close()">
      {{ 'labels.buttons.Define Working Days' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); previousStep()">
      {{ 'labels.buttons.Back' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); nextStep()">
      {{ 'labels.buttons.Next' | translate }}
    </button>
  </div>
</ng-template>
